import React, { useState, useEffect } from 'react';
import { Modal } from '../Modal/Modal';

interface RejectReasonDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (reason?: string) => void;
  isSubmitting?: boolean;
}

export function RejectReasonDialog({
  isOpen,
  onClose,
  onConfirm,
  isSubmitting = false,
}: RejectReasonDialogProps) {
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (isOpen) setReason('');
  }, [isOpen]);

  const handleConfirm = () => {
    onConfirm(reason.trim() || undefined);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Reject item"
      footer={
        <>
          <button className="btn btn--ghost" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </button>
          <button className="btn btn--danger" onClick={handleConfirm} disabled={isSubmitting}>
            {isSubmitting ? 'Rejecting…' : 'Reject item'}
          </button>
        </>
      }
    >
      <div className="form-control">
        <label htmlFor="reject-reason">Reason (optional)</label>
        <textarea
          id="reject-reason"
          className="modal__textarea"
          placeholder="Briefly explain why this item is rejected…"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          rows={4}
        />
        <small className="muted">
          This note will appear on the order's timeline for the customer.
        </small>
      </div>
    </Modal>
  );
}
